import { Box, Chip } from "@mui/material";

export default function SuccessLabel({ text }) {
  return (
    <Box className="w-full">
      <Chip
        className="chipContainer w-full"
        sx={{
          backgroundColor: "#00B4CB",
          color: "black",
          borderColor: "green",
          width: '100% !important;'
        }}
        label={text}
      />
    </Box>
  );
}
